import request from '@/utils/request'

const recyclingBin = {
  name: 'recyclingBin',
  state: {
    isRecyclingBinDetailLoading: false,
    recyclingBinDetailData: {},
    recyclingBinDetailDataMore: {}
  },

  mutations: {
    SET_IS_MODULES_RECYCLINGBIN_DETAIL_LOADING: (state, data) => {
      state.isRecyclingBinDetailLoading = data
    },
    SET_MODULES_RECYCLINGBIN_DETAIL_DATA: (state, data) => {
      state.recyclingBinDetailData = data
    },
    SET_MODULES_RECYCLINGBIN_DETAIL_DATA_MORE: (state, data) => {
      state.recyclingBinDetailDataMore = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryRecyclingBinDetailData({ commit }, id) {
      commit('SET_IS_MODULES_RECYCLINGBIN_DETAIL_LOADING', true)
      commit('SET_MODULES_RECYCLINGBIN_DETAIL_DATA', {})
      commit('SET_MODULES_RECYCLINGBIN_DETAIL_DATA_MORE', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/ablHardware/detail?id=' + id,
          method: 'get'
        }).then(response => {
          request({
            url: '/modules/ablHardware/detailStat?id=' + id,
            method: 'get'
          }).then(responseMore => {
            commit('SET_IS_MODULES_RECYCLINGBIN_DETAIL_LOADING', false)
            commit('SET_MODULES_RECYCLINGBIN_DETAIL_DATA', response.data)
            commit('SET_MODULES_RECYCLINGBIN_DETAIL_DATA_MORE', responseMore.data)
            resolve(responseMore.data)
          }).catch(error => {
            commit('SET_IS_MODULES_RECYCLINGBIN_DETAIL_LOADING', false)
            reject(error)
          })
        }).catch(error => {
          commit('SET_IS_MODULES_RECYCLINGBIN_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetRecyclingBinDetailData({ commit }) {
      commit('SET_MODULES_RECYCLINGBIN_DETAIL_DATA', {})
      commit('SET_MODULES_RECYCLINGBIN_DETAIL_DATA_MORE', {})
    }
  }
}

export default recyclingBin
